import {billingActionTypes as types} from '../actions/actionTypes';

const initialState = {
  addOns: [],
  isLoading: false,
  isValidatingCoupon: false,
  plans: [],
  selectedFrequency: 'Monthly',
  selectedPlan: {},
  selectedPlanLoading: false,
  subscriptionInfo: null,
  planProducts: {
    users: {},
    platform: {},
    addOns: [],
    otherProducts: [],
  },
  productSelections: {
    numUsers: 0,
    addOns: {},
    otherProducts: {},
    coupon: '',
  },
  verifiedCoupon: null,
};

export default function billing(state = initialState, action) {
  switch (action.type) {
    case types.BILLING_GET_PLANS_SUCCESS:
      return {...state, plans: action.plans, isLoading: false};

    case types.BILLING_GET_PLANS_LOADING:
    case types.BILLING_CUSTOMER_CREATING:
      return {...state, isLoading: true};

    case types.BILLING_GET_PLANS_COMPLETE:
      return {...state, isLoading: false};

    case types.BILLING_GET_PRODUCTS_COMPLETE:
      return {...state, isLoading: false};

    case types.BILLING_SELECTED_PLAN_CHANGED:
      return {
        ...state,
        selectedPlan: action.selectedPlan,
        productSelections: {
          ...state.productSelections,
          addOns: {},
          numUsers: action.selectedPlan.maxUsers,
        },
      };

    case types.BILLING_SELECTED_PLAN_LOADING:
      return {...state, selectedPlanLoading: true};

    case types.BILLING_SELECTED_PLAN_LOADED:
      return {
        ...state,
        planProducts: action.planProducts,
        selectedPlanLoading: false,
      };

    case types.BILLING_SELECTED_FREQUENCY_CHANGED:
      return {...state, selectedFrequency: action.selectedFrequency};

    case types.LOAD_COUPON_SUCCESS:
      return {...state, verifiedCoupon: action.coupon};

    case types.BILLING_UPDATE_PLAN_PRODUCT_SELECTIONS:
      return {...state, productSelections: action.productSelections};

    case types.BILLING_VALIDATE_COUPON_LOADING:
      return {...state, isValidatingCoupon: true};

    case types.BILLING_VALIDATE_COUPON_COMPLETE:
      return {
        ...state,
        isValidatingCoupon: false,
        verifiedCoupon: action.coupon,
      };

    case types.BILLING_CUSTOMER_CREATED:
      return {
        ...state,
        isLoading: false,
        subscriptionInfo: action.subscriptionInfo,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/billingReducer.js